import React, { useContext } from 'react';
import './specializedTeam.css';
import { LanguageContext } from '../../../context/LanguageContext/LanguageContext';
import { specializedTeamData, specializedTeamDataEn } from '../../../json/nosotros/specializedTeamData';
// import { Parallax } from 'react-scroll-parallax';

const SpecializedTeam = () => {
    const { language } = useContext(LanguageContext);
    const content = language === 'ES' ? specializedTeamData[0] : specializedTeamDataEn[0];

    return (
        <div className='container'>
            <div className='row'>
                <div className='col-12 pd-0'>
                    {/* <Parallax speed={-5}> */}
                        <div className="specialized-team-container">
                            <div
                                className="image-side left-image"
                                style={{ backgroundImage: `url(${content.leftImage})` }}
                            ></div>

                            <div className="content-text-center">
                                <span className="highlight">{content.title.highlight}</span>
                                <h1>{content.title.main}</h1>
                                <p dangerouslySetInnerHTML={{ __html: content.description }}></p>
                            </div>

                            <div
                                className="image-side right-image"
                                style={{ backgroundImage: `url(${content.rightImage})` }}
                            ></div>
                        </div>
                    {/* </Parallax> */}
                </div>
            </div>
        </div>
    );
};

export default SpecializedTeam;
